import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";

export const GroupNotAssignedBanner = () => (
  <Banner className="group-card" kind="warning">
    {t("group_configuration_card.group_not_assigned")}
  </Banner>
);
